import { BarsThreeIcon, CloseIcon } from "@vericus/cadmus-icons";
import { ControlButton } from "@vericus/cadmus-ui";

import clsx from "clsx";

import * as styles from "./panel-control.css";

interface PanelControlProps {
  /** Callback for the control button click */
  onClick: () => void;
  /** Open state of the panel */
  isOpen: boolean;
}

/**
 * Displays the control open/close button on the right edge of resizable panel.
 */
export function PanelControl(props: PanelControlProps) {
  const { onClick, isOpen } = props;

  return (
    <div className={clsx(styles.panelControl[isOpen ? "open" : "closed"])}>
      <ControlButton
        aria-label={!isOpen ? "Open outline" : "Close outline"}
        onClick={onClick}
        icon={
          isOpen ? (
            <CloseIcon label="" size={24} />
          ) : (
            <BarsThreeIcon label="" size={24} />
          )
        }
      />
    </div>
  );
}
